import React, {useState} from 'react';
import {
  ContItemClients,
  ContItemsClients,
  ContOurClients,
  TitleOurClients,
} from './OurClients.styles';
import FinicsGray from '../../assets/images/finics-prestamos-medicos-gray.webp';
import FinicsColor from '../../assets/images/finics-prestamos-medicos-color.webp';
import MoneyGray from '../../assets/images/money-giver-financiamiento-gray.webp';
import MoneyColor from '../../assets/images/money-giver-financiamiento-color.webp';
import EnkortoGray from '../../assets/images/enkorto-arrendamiento-celular-gray.webp';
import EnkortoColor from '../../assets/images/enkorto-arrendamiento-celular-color.webp';
import EnpagosGray from '../../assets/images/enpagos-equipo-de-trabajo-gray.webp';
import EnpagosColor from '../../assets/images/enpagos-equipo-de-trabajo-color.webp';
import IctineoGray from '../../assets/images/ictineo-prestamos-gray.webp';
import IctineoColor from '../../assets/images/ictineo-prestamos-color.webp';

const ItemClient = ({imgGray = '', imgColor = '', alt = ''}) => {
  const [client, setClient] = useState(imgGray);

  return (
    <img
      src={client}
      alt={alt}
      width={'100%'} 
      height={'auto'}
      onMouseOver={() => {
        setClient(imgColor);
      }}
      onMouseOut={() => {
        setClient(imgGray);
      }}
    />
  );
};

export const OurClients = () => {
  return (
    <ContOurClients>
      <div className={'section-first container-fit'}>
        <TitleOurClients>Nuestros clientes</TitleOurClients>
        <ContItemsClients id={'ContItemsClients'}>
          <ContItemClients>
            <ItemClient imgGray={FinicsGray} imgColor={FinicsColor} alt={'Logo Finics'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={EnpagosGray} imgColor={EnpagosColor} alt={'Logo Enpagos'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={MoneyGray} imgColor={MoneyColor} alt={'Logo Money Giver'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={EnkortoGray} imgColor={EnkortoColor} alt={'Logo enKorto'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={IctineoGray} imgColor={IctineoColor} alt={'Logo Ictineo'}/>
          </ContItemClients>
        </ContItemsClients>
      </div>
    </ContOurClients>
  );
};
